module.exports = __webpack_public_path__ + "4ba1ef81ed4ed906dd56df6d87bc5e05.svg";